module.exports = __webpack_public_path__ + "static/media/event03.ee0ca703.jpg";